import { render, staticRenderFns } from "./AdditionalProgressInformationRow.vue?vue&type=template&id=0c87bb36&scoped=true"
import script from "./AdditionalProgressInformationRow.vue?vue&type=script&lang=js"
export * from "./AdditionalProgressInformationRow.vue?vue&type=script&lang=js"
import style0 from "./AdditionalProgressInformationRow.vue?vue&type=style&index=0&id=0c87bb36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c87bb36",
  null
  
)

export default component.exports